export default {
  sections: {
    order_summary: 'Bestellübersicht',
  },
  labels: {
    add_items: 'Artikel hinzufügen, um loszulegen',
  },
  buttons: {
    return: 'Zurück',
  },
  tip: 'Trinkgeld',
};
